import { useQuery } from '@tanstack/react-query';

import { SEASON_DIVISION_INFO_QUERY_KEY } from '@/hooks/leagueSeasonDivision/constants';
import { getTeamLeagueSeasonDivision } from '@/infrastructure/network/data/season-divisions/season-division';
import { useOrganizationStore } from '@/store/organization-store';

export const useTeamLeagueSeasonDivision = ({
	seasonUuid,
	districtUuid,
	divisionUuid
}: {
	seasonUuid: string;
	districtUuid: string;
	divisionUuid: string;
}) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: [SEASON_DIVISION_INFO_QUERY_KEY, store.organizationUuid, store.teamLeagueUuid, seasonUuid, districtUuid, divisionUuid],
		queryFn: () =>
			getTeamLeagueSeasonDivision({
				organizationUuid: store.organizationUuid,
				teamLeagueUuid: store.teamLeagueUuid,
				seasonUuid,
				districtUuid,
				divisionUuid
			}),
		enabled: !!store.organizationUuid && !!store.teamLeagueUuid && !!seasonUuid && !!districtUuid && !!divisionUuid
	});
};
